declare global {
    namespace JSX {
        interface IntrinsicElements {
            'w-badge': any,
            'w-table': any,
            'w-user-info': any
        }
    }
}
import '@amzn/alchemy-components/dist/styles/font-inter.css';
import '@amzn/alchemy-components/dist/styles/global.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "../app.scss";

import React from "react";
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './components/App';
// Import the Redux Toolkit store instead of the old store
import store from './store';

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('app')
);
